import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Preferences } from "@capacitor/preferences";
import API from "../api";
import socket from "../socket";
import cryptoService from "../services/cryptoService";

function Profile() {
  const [profile, setProfile] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    role: "",
  });

  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [devices, setDevices] = useState([]);
  const [pendingDevice, setPendingDevice] = useState(null);
const [showDeviceModal, setShowDeviceModal] = useState(false);
const [syncingDeviceId, setSyncingDeviceId] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
  fetchProfile();
  fetchDevices();
}, []);

useEffect(() => {
  const onPending = (device) => {
  fetchDevices();
  setPendingDevice(device);
  setShowDeviceModal(true);
};

  const onApproved = () => {
    fetchDevices();
    alert("✅ Cet appareil a été approuvé.");
  };

  const onRevoked = () => {
    fetchDevices();
    alert("❌ Cet appareil a été révoqué.");
  };

  if (!socket.connected) {
  socket.connect();
}

  socket.on("device:pending", onPending);
  socket.on("device:approved", onApproved);
  socket.on("device:revoked", onRevoked);

  return () => {
    socket.off("device:pending", onPending);
    socket.off("device:approved", onApproved);
    socket.off("device:revoked", onRevoked);
  };
}, []);

  const fetchProfile = async () => {
    try {
      const res = await API.get("/me");
      setProfile(res.data);
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de charger le profil");
    }
  };

  const fetchDevices = async () => {
  try {
    const res = await API.get("/users/devices");
    setDevices(res.data);
  } catch (err) {
    console.log("Erreur appareils:", err);
  }
};


const syncDeviceHistory = async (targetKeyId) => {
  try {
    setSyncingDeviceId(targetKeyId);

    const keys = await cryptoService.getKeys();

    if (!keys?.privateKey) {
      alert("Pas de clé privée locale sur cet appareil");
      return;
    }

    const res = await API.get(`/users/devices/${targetKeyId}/sync-messages`);

    const targetPublicKey = res.data.targetKey?.publicKey;
const messages = res.data.messages || [];

console.log("SYNC RESPONSE", {
  localKeyId: keys.keyId,
  targetKeyId,
  backendCurrentKeyId: res.data.currentKeyId,
  messagesCount: messages.length,
  targetKey: res.data.targetKey,
  firstMessage: messages[0],
});

if (!targetPublicKey || messages.length === 0) {
  alert(
    `Aucun message à synchroniser depuis cet appareil\n\n` +
    `Clé locale : ${keys.keyId}\n` +
    `Clé backend : ${res.data.currentKeyId}\n` +
    `Clé cible : ${targetKeyId}\n` +
    `Messages : ${messages.length}`
  );
  return;
}

    const syncedMessages = [];

    for (const msg of messages) {
      try {
        const clearText = cryptoService.decryptMessage(
          msg.encrypted_text,
          msg.nonce,
          msg.encryptor_public_key,
          keys.privateKey
        );

        if (!clearText) continue;

        const encrypted = cryptoService.encryptMessage(
          clearText,
          targetPublicKey,
          keys.privateKey
        );

        syncedMessages.push({
          messageId: msg.message_id,
          type: msg.type,
          encrypted: encrypted.encrypted,
          nonce: encrypted.nonce,
        });
      } catch (err) {
        console.log("Message impossible à synchroniser:", msg.message_id, err);
      }
    }

    if (syncedMessages.length === 0) {
      alert("Aucun message rechiffré depuis cet appareil");
      return;
    }

    const saveRes = await API.post(`/users/devices/${targetKeyId}/sync-messages`, {
      messages: syncedMessages,
    });

    alert(`${saveRes.data.inserted || syncedMessages.length} message(s) synchronisé(s)`);
  } catch (err) {
    console.log("Erreur synchronisation historique:", err);
    alert(err?.response?.data?.message || "Erreur synchronisation historique");
  } finally {
    setSyncingDeviceId(null);
  }
};

const approveDevice = async (id) => {
  try {
    await API.post(`/users/devices/${id}/approve`);

    await syncDeviceHistory(id);

    await fetchDevices();

    alert("Appareil approuvé et historique synchronisé");
  } catch (err) {
    alert(err?.response?.data?.message || "Impossible d'approuver l'appareil");
  }
};

const revokeDevice = async (id) => {
  if (!window.confirm("Révoquer cet appareil ?")) return;

  try {
    await API.post(`/users/devices/${id}/revoke`);
    await fetchDevices();
    alert("Appareil révoqué");
  } catch (err) {
    alert(err?.response?.data?.message || "Impossible de révoquer l'appareil");
  }
};

const approvePendingDevice = async () => {
  if (!pendingDevice) return;

  await approveDevice(pendingDevice.keyId);
  setShowDeviceModal(false);
  setPendingDevice(null);
};

const rejectPendingDevice = async () => {
  if (!pendingDevice) return;

  await revokeDevice(pendingDevice.keyId);
  setShowDeviceModal(false);
  setPendingDevice(null);
};

  const updateProfile = async () => {
    try {
      const res = await API.put("/me", profile);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      alert("Profil mis à jour");
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de modifier le profil");
    }
  };

  const updatePassword = async () => {
    try {
      await API.put("/me/password", passwords);

      setPasswords({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });

      alert("Mot de passe modifié");
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de modifier le mot de passe");
    }
  };

  const logout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");

    await Preferences.remove({ key: "token" });
    await Preferences.remove({ key: "refreshToken" });

    navigate("/login");
    window.location.reload();
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
  <div style={styles.headerLeft}>
        <div style={styles.avatar}>{profile.firstname?.[0] || "?"}</div>

        <div>
          <div style={styles.name}>
            {profile.firstname} {profile.lastname}
          </div>
          <div style={styles.role}>{formatRole(profile.role)}</div>
        </div>
          </div>

  <button
    style={styles.logoutIconBtn}
    onClick={() => setShowLogoutModal(true)}
  >
    ↪
  </button>
      </div>

{devices.some((d) => d.status === "pending") && (
  <div style={styles.deviceBanner}>
    🔐 Un appareil est en attente d'approbation
  </div>
)}

      <div style={styles.card}>
        <div style={styles.sectionTitle}>Mes informations</div>

        <input
          style={styles.input}
          placeholder="Prénom"
          value={profile.firstname || ""}
          onChange={(e) => setProfile({ ...profile, firstname: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Nom"
          value={profile.lastname || ""}
          onChange={(e) => setProfile({ ...profile, lastname: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Email"
          value={profile.email || ""}
          onChange={(e) => setProfile({ ...profile, email: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Téléphone"
          value={profile.phone || ""}
          onChange={(e) => setProfile({ ...profile, phone: e.target.value })}
        />

        <button style={styles.primaryBtn} onClick={updateProfile}>
          Sauvegarder mes infos
        </button>
      </div>

      <div style={styles.card}>
        <div style={styles.sectionTitle}>Mot de passe</div>

        <input
          style={styles.input}
          type="password"
          placeholder="Mot de passe actuel"
          value={passwords.currentPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, currentPassword: e.target.value })
          }
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Nouveau mot de passe"
          value={passwords.newPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, newPassword: e.target.value })
          }
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Confirmer le nouveau mot de passe"
          value={passwords.confirmPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, confirmPassword: e.target.value })
          }
        />

        <button style={styles.secondaryBtn} onClick={updatePassword}>
          Modifier le mot de passe
        </button>
      </div>
      
      <div style={styles.card}>
  <div style={styles.sectionTitle}>Mes appareils</div>

  {devices.length === 0 ? (
    <div style={styles.deviceText}>Aucun appareil enregistré</div>
  ) : (
    devices.map((device) => (
      <div key={device.id} style={styles.deviceItem}>
        <div>
          <div style={styles.deviceName}>
            {device.device_name || "Appareil inconnu"}
          </div>
          <div style={styles.deviceText}>
  {formatDeviceStatus(device.status)}
  {" · "}
  Clé #{device.id}
{" · "}
{formatDeviceStatus(device.status)}
{" · "}
{device.last_seen ? new Date(device.last_seen).toLocaleString("fr-FR") : "Jamais connecté"}
</div>
        </div>

        <div style={styles.deviceActions}>
          {device.status === "pending" && (
            <button style={styles.approveBtn} onClick={() => approveDevice(device.id)}>
              Approuver
            </button>
          )}

          {device.status === "approved" && (
  <>
    <button
      style={styles.approveBtn}
      onClick={() => syncDeviceHistory(device.id)}
      disabled={syncingDeviceId === device.id}
    >
      {syncingDeviceId === device.id ? "Synchro..." : "Synchroniser"}
    </button>

    <button style={styles.revokeBtn} onClick={() => revokeDevice(device.id)}>
      Révoquer
    </button>
  </>
)}
        </div>
      </div>
    ))
  )}
</div>

{showDeviceModal && pendingDevice && (
  <div style={styles.modalOverlay}>
    <div style={styles.modalBox}>
      <div style={styles.modalIcon}>🔐</div>

      <h3 style={styles.modalTitle}>Nouvel appareil détecté</h3>

      <p style={styles.modalText}>
        {pendingDevice.deviceName || "Nouvel appareil"} demande l'accès à votre compte.
      </p>

      <div style={styles.modalActions}>
        <button style={styles.modalCancel} onClick={rejectPendingDevice}>
          Refuser
        </button>

        <button style={styles.modalConfirm} onClick={approvePendingDevice}>
          Approuver
        </button>
      </div>
    </div>
  </div>
)}

      {showLogoutModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <div style={styles.modalIcon}>🚪</div>
            <h3 style={styles.modalTitle}>Se déconnecter ?</h3>
            <p style={styles.modalText}>
              Tu devras te reconnecter pour accéder à l’application.
            </p>

            <div style={styles.modalActions}>
              <button
                style={styles.modalCancel}
                onClick={() => setShowLogoutModal(false)}
              >
                Annuler
              </button>

              <button style={styles.modalConfirm} onClick={logout}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function formatRole(role) {
  switch (role) {
    case "admin":
      return "Admin";
    case "apprenti":
      return "Apprenti";
    case "compagnon":
      return "Compagnon";
    case "maitre":
      return "Maître";
    default:
      return role || "";
  }
}

function formatDeviceStatus(status) {
  switch (status) {
    case "approved":
      return "✅ Approuvé";
    case "pending":
      return "⏳ En attente";
    case "revoked":
      return "❌ Révoqué";
    default:
      return status;
  }
}

export default Profile;

const styles = {

  deviceItem: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  padding: 12,
  borderRadius: 14,
  background: "rgba(255,255,255,0.75)",
  border: "1px solid rgba(143,174,93,0.18)",
  marginBottom: 10,
},

deviceName: {
  fontWeight: "700",
  color: "#3B3450",
},
deviceBanner: {
  padding: 12,
  marginBottom: 16,
  borderRadius: 14,
  background: "rgba(143,174,93,0.14)",
  border: "1px solid rgba(143,174,93,0.28)",
  color: "#3B3450",
  fontWeight: "700",
  fontSize: 13,
},

deviceText: {
  fontSize: 12,
  color: "#6B6780",
  marginTop: 4,
},

deviceActions: {
  display: "flex",
  gap: 8,
},

approveBtn: {
  padding: "9px 11px",
  borderRadius: 10,
  border: "none",
  background: "linear-gradient(135deg, #8FAE5D, #9AB86A)",
  color: "#fff",
  fontWeight: "700",
},

revokeBtn: {
  padding: "9px 11px",
  borderRadius: 10,
  border: "1px solid rgba(180,60,60,0.35)",
  background: "rgba(180,60,60,0.10)",
  color: "#b43c3c",
  fontWeight: "700",
},

  container: {
    height: "100vh",
    overflowY: "auto",
    background: "linear-gradient(180deg, #F4F0FA 0%, #E6DDF4 100%)",
    color: "#3B3450",
    padding: 20,
    paddingBottom: 150,
    boxSizing: "border-box",
  },

  header: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 22,
},

  headerLeft: {
  display: "flex",
  alignItems: "center",
  gap: 15,
},

logoutIconBtn: {
  width: 46,
  height: 46,
  borderRadius: 14,
  border: "1px solid rgba(143,174,93,0.25)",
  background: "rgba(255,255,255,0.85)",
  color: "#8FAE5D",
  fontSize: 22,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 0 20px rgba(212,175,55,0.08)",
  cursor: "pointer",
  transition: "all 0.2s ease",
  WebkitTapHighlightColor: "transparent",
},

  avatar: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.90)",
    border: "1px solid rgba(143,174,93,0.25)",
    color: "#8FAE5D",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
    fontWeight: "700",
    boxShadow: "0 0 25px rgba(212,175,55,0.25)",
  },

  name: {
    fontSize: 20,
    fontWeight: "700",
    color: "#3B3450",
  },

  role: {
    fontSize: 13,
    color: "#6B6780",
    marginTop: 4,
  },

  card: {
    background: "rgba(255,255,255,0.90)",
    border: "1px solid rgba(143,174,93,0.20)",
    borderRadius: 18,
    padding: 18,
    marginBottom: 16,
    backdropFilter: "blur(12px)",
    boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
  },

  sectionTitle: {
    color: "#3B3450",
    fontWeight: "700",
    marginBottom: 12,
  },

  input: {
    width: "100%",
    padding: 13,
    marginBottom: 10,
    borderRadius: 12,
    border: "1px solid rgba(143,174,93,0.25)",
    background: "rgba(255,255,255,0.95)",
    color: "#3B3450",
    boxSizing: "border-box",
  },

  primaryBtn: {
    width: "100%",
    padding: 14,
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#fff",
    fontWeight: "700",
    marginTop: 6,
    cursor: "pointer",
  },

  secondaryBtn: {
    width: "100%",
    padding: 14,
    borderRadius: 12,
    border: "1px solid rgba(143,174,93,0.35)",
    background: "rgba(143,174,93,0.10)",
    color: "#8FAE5D",
    fontWeight: "700",
    marginTop: 6,
    cursor: "pointer",
  },


  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.75)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    zIndex: 9999,
  },

  modalBox: {
    width: "100%",
    maxWidth: 340,
    background: "rgba(255,255,255,0.95)",
    border: "1px solid rgba(143,174,93,0.25)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 20px 70px rgba(0,0,0,0.9)",
    textAlign: "center",
  },

  modalIcon: {
    fontSize: 34,
    marginBottom: 10,
  },

  modalTitle: {
    color: "#3B3450",
    fontSize: 21,
    margin: "0 0 8px",
  },

  modalText: {
    color: "#6B6780",
    fontSize: 14,
    lineHeight: 1.5,
    marginBottom: 20,
  },

  modalActions: {
    display: "flex",
    gap: 10,
  },

  modalCancel: {
    flex: 1,
    padding: 13,
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.85)",
    color: "#3B3450",
    fontWeight: "700",
    cursor: "pointer",
  },

  modalConfirm: {
    flex: 1,
    padding: 13,
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #8FAE5D, #9AB86A)",
    color: "#fff",
    fontWeight: "800",
    cursor: "pointer",
  },
};